import type { ReactNode } from 'react';
import { TriangleAlert } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui/core/Button';

export type ErrorStateProps = {
  title: string;
  description?: string;
  onRetry?: () => void;
  retryLabel?: string;
  action?: ReactNode;
  className?: string;
  variant?: 'inline' | 'page';
};

export function ErrorState({
  title,
  description,
  onRetry,
  retryLabel = 'Thử lại',
  action,
  className,
  variant = 'inline',
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex flex-col items-center justify-center gap-3 text-center',
        variant === 'page' ? 'px-4 py-16' : 'px-4 py-8',
        className,
      )}
    >
      <div className="flex size-12 items-center justify-center rounded-full bg-danger-soft text-danger-fg">
        <TriangleAlert className="size-6" aria-hidden />
      </div>
      <div>
        <h3 className="text-h3 m-0 text-text">{title}</h3>
        {description ? (
          <p className="mt-1 mb-0 max-w-md text-body text-text-secondary">{description}</p>
        ) : null}
      </div>
      {action ??
        (onRetry ? (
          <Button variant="secondary" onClick={onRetry}>
            {retryLabel}
          </Button>
        ) : null)}
    </div>
  );
}
